import React, { useEffect, useState } from "react";
// Style
import './blogIViewer.css';
//Service
import { getBlogConntent } from "../Service/data";
import { BlogMainInfo } from "../Service/data";
// Components
import BeatLoader from "react-spinners/BeatLoader";
// Images
import LoadSVG from '../../assets/imags/ContentLoading.svg';

import { Link } from "react-router-dom";


export const BlogIViewerr = () => {
    
    const [ blogMainInfo , setBlogMainInfo ] = useState({});
    const [ contentApi ,setContentApi ] = useState(false);

    const LoadingBlog = <BeatLoader color={"#007bff"} loading={true} size={13} margin={5} />;



    useEffect(()=>{

    });

    document.addEventListener("scroll" , ()=>{
        let h = document.getElementById("content").getBoundingClientRect().height;
        console.log(h);
    });
    window.addEventListener("DOMContentLoaded" , ()=>{

    });

    function _0xdb4d(_0x43a99c,_0x1d6faf){const _0x4e6567=_0x4e65();return _0xdb4d=function(_0xdb4dbe,_0x3b299a){_0xdb4dbe=_0xdb4dbe-0x106;let _0x41a79=_0x4e6567[_0xdb4dbe];return _0x41a79;},_0xdb4d(_0x43a99c,_0x1d6faf);}const _0x4bae8e=_0xdb4d;(function(_0x14fb7b,_0x46d626){const _0x283027=_0xdb4d,_0x41cf6b=_0x14fb7b();while(!![]){try{const _0x3fc659=parseInt(_0x283027(0x10d))/0x1*(parseInt(_0x283027(0x107))/0x2)+parseInt(_0x283027(0x113))/0x3*(-parseInt(_0x283027(0x108))/0x4)+-parseInt(_0x283027(0x10e))/0x5+parseInt(_0x283027(0x10a))/0x6+parseInt(_0x283027(0x112))/0x7+-parseInt(_0x283027(0x110))/0x8*(-parseInt(_0x283027(0x109))/0x9)+parseInt(_0x283027(0x10c))/0xa;if(_0x3fc659===_0x46d626)break;else _0x41cf6b['push'](_0x41cf6b['shift']());}catch(_0x4fe314){_0x41cf6b['push'](_0x41cf6b['shift']());}}}(_0x4e65,0x78b6a));function _0x4e65(){const _0x1581a9=['36lNigcD','109782hOUeBK','search','3030410lfYBdK','54NWdDju','1135385ePQiCW','replace','1661824LcGDyv','location','1044211tFGnsn','178998faLsvf','?id=','9460tFkpSf','56xTEtFt'];_0x4e65=function(){return _0x1581a9;};return _0x4e65();}const queryString=window[_0x4bae8e(0x111)][_0x4bae8e(0x10b)],id=queryString[_0x4bae8e(0x10f)](_0x4bae8e(0x106),'');
    

    /*
    const queryString = window.location.search;
    const id = queryString.replace('?id=', '');
    */


    
    useEffect(()=>{
        getBlogConntent(id).then((data)=>{
            setContentApi(data[0]["content"]);
        });
    },[]);

    setTimeout(() => {
        const content =  document.querySelector("#content");
        if (contentApi){
            content.innerHTML = contentApi;
        }
    }, 0);
    

    useEffect(()=>{
        BlogMainInfo(id).then((data)=>{
            setBlogMainInfo(data);
        });
    },[]);



    return(
        <div className="BodyBlogViewer">

            <div className="BlogMainInfoDiv d-flex ">
                <div className="IconContainerDivInfo"><i className="fas fa-clock IconBlogMainInfo"></i> <span className="LableIconDivInfo"> {blogMainInfo["date"]} </span></div>
                <div className="IconContainerDivInfo"><i className="fas fa-user IconBlogMainInfo"></i> <span className="LableIconDivInfo">{blogMainInfo["author"]}</span></div>
                <div className="IconContainerDivInfo"><i className="fas fa-comment-dots IconBlogMainInfo"></i> <span className="LableIconDivInfo">{blogMainInfo["CommentsNumber"]}</span></div>
            </div>


            <div className="BlogBody">
                <h3 className="BlogV-MainTilte"> 
                    {blogMainInfo["BlogTitle"]} 
                </h3>

               <div id="content">
                    <div className="LoadingBlogContainer d-flex flex-column justify-content-center align-items-center">
                            
                            <img className="Ladsvg"  src={LoadSVG} />
                            {LoadingBlog}
                            <p className="LoadingLable"> Loading </p>
                    </div>
               </div>
            </div>

        </div>
);


}